import InputText from '@viking-eng/input-text';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { APP_PAGES, EDIT_FORM_TYPE } from 'common/Constants';
import { email, ERROR_CODES, ERROR_MESSAGES, required } from 'common/forms/Validations';

const ConfirmEmailForm = ({ bookingId, cruiseName, onEmailChange, user }) => {
  const formType = window.location?.pathname?.startsWith(APP_PAGES.USERS.path)
    ? EDIT_FORM_TYPE.B2C_USER
    : EDIT_FORM_TYPE.MVJ_USER;

  if (formType === EDIT_FORM_TYPE.MVJ_USER) {
    if (!bookingId || !cruiseName) {
      return null;
    }
  }

  const confirmEmailTitle =
    formType === EDIT_FORM_TYPE.MVJ_USER
      ? "Please confirm the email address on the guest's MVJ Account."
      : 'Please confirm the email address on the B2C Login Account.';

  const getDetailElement = ({ currentValue, fieldName }) => {
    return (
      <div className="edit-name-detail-wrapper row no-gutters d-block">
        <div className="edit-name-title col-3">{`${fieldName}:`}</div>
        <div className="edit-name-value col-8">{currentValue}</div>
      </div>
    );
  };

  return (
    <div className="confirm-email-form">
      <div className="subtitle">{confirmEmailTitle}</div>
      <div className="row no-gutters edit-name-fields">
        <div className="col-md-7 m-auto">
          {formType === EDIT_FORM_TYPE.MVJ_USER ? (
            <div>
              {getDetailElement({ fieldName: 'Booking ID', currentValue: bookingId })}
              {getDetailElement({ fieldName: 'Cruise Name', currentValue: cruiseName })}
              {getDetailElement({ fieldName: 'Guest Name', currentValue: `${user.firstName} ${user.lastName}` })}
            </div>
          ) : (
            <div>{getDetailElement({ fieldName: 'B2C User', currentValue: `${user.firstName} ${user.lastName}` })}</div>
          )}
          <div className="edit-name-form-input-wrapper">
            <Field
              component={InputText}
              errorCodes={{
                [ERROR_CODES.INVALID_EMAIL_FORMAT]: ERROR_CODES.INVALID_EMAIL_FORMAT,
                [ERROR_CODES.REQUIRED]: ERROR_CODES.EMAIL_REQUIRED,
              }}
              errorMessages={ERROR_MESSAGES}
              id="email"
              name="email"
              normalize={(value) => value?.trim()}
              placeholder="Email"
              type="email"
              validate={[required, email]}
              onChange={onEmailChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmEmailForm.propTypes = {
  bookingId: PropTypes.string,
  cruiseName: PropTypes.string,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  onEmailChange: PropTypes.func,
};

ConfirmEmailForm.defaultProps = {
  bookingId: null,
  cruiseName: null,
  onEmailChange: () => null,
};

export default ConfirmEmailForm;
